import type { RolePlayConfig, RolePlayScenario } from "@/lib/powtoon-be/types";
import { singleScenarioOf } from "./schema";

type RolePlayValidationError = { message: string };

export function validateRolePlay(cfg: RolePlayConfig): RolePlayValidationError[] {
  const errors: RolePlayValidationError[] = [];
  if (!cfg.goal.trim()) errors.push({ message: "Training goal is required" });
  const s = singleScenarioOf(cfg);
  if (!s.avatar_role.trim()) errors.push({ message: "Avatar role is required" });
  if (!s.learner_role.trim()) errors.push({ message: "Learner role is required" });
  const terms = s.assessment.termination_conditions.filter((t) => t.trim());
  if (terms.length === 0)
    errors.push({ message: "At least one termination condition is required" });
  return errors;
}

export function scenarioSummary(s: RolePlayScenario): string {
  const a = s.avatar_role.trim() || "Avatar";
  const l = s.learner_role.trim() || "Learner";
  return `${a} ↔ ${l}`;
}
